import React, { useState } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  AttachedTable,
  ConditionFeature,
  UpgradableNumber,
} from "@dndModels";

import ToggleButtonBox from "@components/input/buttons/ToggleButtonBox";
import SelectConditionBox from "@dndComponents/select/SelectConditionBox";
import UpgradableNumberBox from "@dndComponents/UpgradableNumberBox";

interface Props {
  sff: ConditionFeature;
  onChange: (sff: ConditionFeature) => void; 
  disabled: boolean;
  attached_table?: AttachedTable;
}

export default function ConditionFeatureInput({ 
  sff,
  onChange,
  disabled,
  attached_table
}: Props) {
  const [ping, setPing] = useState(false);

  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 12
        }}>
        <SelectConditionBox 
          name="Condition" 
          value={sff.condition_id} 
          disabled={disabled}
          onChange={(changed: string) => {
            const obj = sff;
            obj.condition_id = changed;
            onChange(obj);
            setPing(!ping);
          }} 
        />
      </Grid>
      <Grid
        size={{
          xs: 12
        }}>
        <UpgradableNumberBox 
          name="Level"
          value={sff.level} 
          disabled={disabled}
          attached_table={attached_table}
          onChange={(changed: UpgradableNumber) => {
            const obj = sff;
            obj.level = changed;
            onChange(obj);
            setPing(!ping);
          }} 
        />
      </Grid>
      <Grid
        size={{
          xs: 12
        }}>
        <ToggleButtonBox 
          name="Immunity"
          value={sff.immunity}
          disabled={disabled}
          onToggle={() => {
            const obj = sff;
            obj.immunity = !obj.immunity;
            onChange(obj);
            setPing(!ping);
          }} 
        />
      </Grid>
    </Grid>
  );
}
